export default "__VITE_ASSET__BfSQ8k68__"